import React from "react";
import globalContext from "../../context/globalContext";
import {
  Dialog,
  Button,
  CircularProgress,
  TextField,
  InputAdornment
} from "@material-ui/core";
import s from "./shoppingCart.module.css";
import {
  CheckBoxOutlined,
  CheckBoxOutlineBlank,
  CloseRounded
} from "@material-ui/icons";

import {
  Elements,
  StripeProvider,
} from "react-stripe-elements";

import { InjectedCardForm } from "../PaymentMethods";
import config from "../../configuration/config";
import { isInt } from "validator";

class PayDialog extends React.Component {
  static contextType = globalContext;
  state = {
    paymentOption: 1,
    selectedOptionUuid: null,
    showAddNewCard: false,
    snapAgreeFlag: false,
    tipAmountDollars: "0",
    selectedTip: 1
  };

  async componentWillMount() {
    await this.context.global.getUserByUuid();

    if (this.context.global.data.user.account.paymentOptions.length > 0) {
      this.setState({
        selectedOptionUuid: this.context.global.data.user.account
          .paymentOptions[0].uuid
      });
    } else {
      this.setState({ showAddNewCard: true });
    }
  }

  selectPaymentOption(pmUuid) {
    this.setState({ selectedOptionUuid: pmUuid });
  }

  selectTip(buttonNumber) {
    const { cartTotal } = this.props.shoppingCart.cartDetails;
    this.setState({ selectedTip: buttonNumber });

    var percent;
    switch (buttonNumber) {
      case 1:
        percent = 0;
        break
      case 2:
        percent = 0.1;
        break
      case 3:
        percent = 0.15;
        break
      case 4:
        percent = 0.2;
        break
      default: 
        percent = 0
    }

    console.log(Math.floor((cartTotal * percent) / 100));
    this.setState({ tipAmountDollars: Math.floor((cartTotal * percent) / 100) });

  }

  handleAdjChange(ev) {
    console.log(ev.target.value);
    const { tipAmountDollars } = this.state;
    if (ev.target.value === "") {
      return this.setState({
        tipAmountDollars: "",
        selectedTip: 1
      });
    }
    if (isInt(ev.target.value)) {
      return this.setState({
        tipAmountDollars: ev.target.value,
        selectedTip: 0
      });
    } else {
      return this.setState({
        tipAmountDollars
      });
    }
  }

  render() {
    const {
      closePayDialog,
      payDialogState,
      shoppingCart,
      orderProcessing,
      placeOrder,
      theme,
      puli
    } = this.props;
    const {
      global: {
        data: { user }
      }
    } = this.context;
    const {
      paymentOption,
      selectedOptionUuid,
      showAddNewCard,
      snapAgreeFlag,
      selectedTip,
      tipAmountDollars
    } = this.state;

    if (!user) {
      return (
        <div>
          <CircularProgress />
        </div>
      );
    }

    return (
      <Dialog
        fullScreen={true}
        onClose={closePayDialog}
        open={payDialogState}
        style={{ zIndex: 90003}}
      >
        <div className={s.paymentDialogContainer}>
          <div>
            <div className={s.payTitle}>Payment Options <div
                  className={s.dialogCloseContainer}
                  onClick={closePayDialog}
                >
                  <CloseRounded
                    style={{
                      color: theme.palette.primary.main,
                      backgroundColor: "white",
                      boxShadow: "1px 1px 1px 1px #999",
                      borderRadius: 20
                    }}
                  />
                </div></div>
            {puli.snapAllowed ? (
              <div className={s.payToggle}>
                <div
                  className={s.payToggleTitle}
                  style={
                    paymentOption === 1
                      ? {
                          background: theme.palette.primary.light,
                          color: "white"
                        }
                      : {}
                  }
                  onClick={() => this.setState({ paymentOption: 1 })}
                >
                  card
                </div>

                <div
                  className={s.payToggleTitle}
                  style={
                    paymentOption === 2
                      ? {
                          background: theme.palette.primary.light,
                          color: "white"
                        }
                      : {}
                  }
                  onClick={() => this.setState({ paymentOption: 2,  
                    tipAmountDollars: "0",
                    selectedTip: 1  
                  })}
                >
                  EBT
                </div>
              </div>
            ) : null}
            <div>
              {paymentOption === 1 ? (
                <div>
                  <div className={s.cardDescription}>
                    Card will be charged upon order pickup.
                    Tips are shared with all employees involved 
                    in your pickup or delivery experience.
                  </div>
                  <div>
                    {user.account.paymentOptions.map(pm => {
                      return (
                        <div
                          className={s.paymentOptionContainer}
                          style={{
                            border:
                              selectedOptionUuid === pm.uuid
                                ? `3px solid ${theme.palette.primary.light}`
                                : undefined
                          }}
                          onClick={this.selectPaymentOption.bind(this, pm.uuid)}
                        >
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {selectedOptionUuid === pm.uuid ? (
                              <CheckBoxOutlined
                                style={{ color: theme.palette.primary.light }}
                              />
                            ) : (
                              <CheckBoxOutlineBlank />
                            )}

                            <div style={{ color: "#555", paddingLeft: 20 }}>
                              {pm.type}{" "}
                              <span style={{ color: "#888", fontSize: 10 }}>
                                ending in
                              </span>{" "}
                              {pm.last4}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    {!showAddNewCard ? (
                      <div
                        className={s.addNewCardContainer}
                        style={{ color: theme.palette.primary.dark }}
                        onClick={() => {
                          this.setState({ showAddNewCard: true });
                        }}
                      >
                        add another card
                      </div>
                    ) : null}
                  </div>
                  <div
                    style={{
                      overflowX: "scroll",
                      width: !showAddNewCard ? 0 : undefined
                    }}
                  >
                    <div className={s.newCardContainer}>
                      <div className={s.newCardContainerTitle}>
                        New Card Information
                      </div>
                      <StripeProvider apiKey={config.stripe.key}>
                        <div className={s.cardDialog}>
                          <Elements>
                            <InjectedCardForm
                              user={user}
                              createPaymentOption={
                                this.context.global.createPaymentOption
                              }
                              closeDialog={() => {
                                //quick hack to clear the stripe entry
                                this.setState({ paymentOption: 2 });
                                this.setState({ paymentOption: 1 });

                                if (
                                  this.context.global.data.user.account
                                    .paymentOptions.length > 0
                                ) {
                                  this.setState({
                                    selectedOptionUuid: this.context.global.data
                                      .user.account.paymentOptions[
                                      this.context.global.data.user.account
                                        .paymentOptions.length - 1
                                    ].uuid
                                  });
                                }

                                this.setState({ showAddNewCard: false });
                              }}
                            />
                          </Elements>
                        </div>
                      </StripeProvider>
                    </div>
                  </div>
                  <div className={s.tip_container}>
                  <div className={s.tip_container_button_row}>
                      <TextField
                        style={{margin: 0}}
                        label="Optional Service Charge(Dollars)"
                        type={"tel"}
                        value={this.state.tipAmountDollars}
                        onChange={this.handleAdjChange.bind(this)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                          type: "tel"
                        }}
                      />
                    </div>
                    <div className={s.tip_container_button_row}>
                      <Button
                        variant={selectedTip === 1 ? "text" : "outlined"}
                        onClick={() => {
                          this.selectTip(1);
                        }}
                      >
                        0%
                      </Button>
                      <Button
                        variant={selectedTip === 2 ? "text" : "outlined"}
                        onClick={() => {
                          this.selectTip(2);
                        }}
                      >
                        10%
                      </Button>
                    {/* </div>
                    <div className={s.tip_container_button_row}> */}
                      <Button
                        variant={selectedTip === 3 ? "text" : "outlined"}
                        onClick={() => {
                          this.selectTip(3);
                        }}
                      >
                        15%
                      </Button>
                      <Button
                        variant={selectedTip === 4 ? "text" : "outlined"}
                        onClick={() => {
                          this.selectTip(4);
                        }}
                      >
                        20%
                      </Button>
                    </div>
                   
                  </div>
                </div>
              ) : null}
              {paymentOption === 2 ? (
                <div style={{ overflowY: "scroll" }}>
                 <div className={s.snapDescription}>
                    <div className={s.snapParagraph}>
                      By selecting this payment option, I am electing to bypass
                      the online payment process so that I can pay with EBT. By
                      selecting this payment option I agree to the following:
                    </div>
                    <div className={s.snapParagraph}>
                      1) I will have my payment available at the location and
                      time specified.
                    </div>
                    <div className={s.snapParagraph}>
                      2) Food Forest has the right to cancel my order and/or
                      account if it appears unusual or suspicious. (to avoid
                      this please add at least one credit or debit payment
                      option to your account)
                    </div>
                  </div>

                  <div
                    className={s.snapAgreeContainer}
                    onClick={() =>
                      this.setState({
                        snapAgreeFlag: !this.state.snapAgreeFlag
                      })
                    }
                  >
                    <div>
                      {snapAgreeFlag ? (
                        <CheckBoxOutlined
                          style={{ color: theme.palette.primary.light }}
                        />
                      ) : (
                        <CheckBoxOutlineBlank />
                      )}{" "}
                    </div>

                    <div className={s.snapAgreeDescription}>
                      I agree! Now get me my food.
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          <Button
            disabled={(() => {
              if (orderProcessing) {
                return true;
              }

              if (paymentOption === 1) {
                if (!selectedOptionUuid) {
                  return true;
                } else {
                  return false;
                }
              } else {
                if (snapAgreeFlag) {
                  return false;
                } else {
                  return true;
                }
              }
            })()}
            style={{
              maxHeight: "2.25rem",
              flex: "none",
              width: "100%",
              marginTop: 10,
              justifySelf: "flex-end"
            }}
            onClick={async () => {
              let tipCheck = 0
              if (paymentOption === 1) {
                tipCheck = tipAmountDollars
              }
              await placeOrder(
                shoppingCart.uuid,
                selectedOptionUuid,
                paymentOption,
                tipCheck
              );
            }}
          >
            {orderProcessing ? (
              <CircularProgress style={{ height: 25, width: 25 }} />
            ) : (
              "Place Order"
            )}
          </Button>
        </div>
      </Dialog>
    );
  }
}

export default PayDialog;
